export const graphSettings = [
    {
        key: 'maxAmplitude',
        label: 'ABB.Powertrain.Frontend.fftEchartMaxAmplitude',
    },
    {
        key: 'toleranceBandWidth',
        label: 'ABB.Powertrain.Frontend.fftEchartToleranceBandWidth',
    },
    {
        key: 'filterThreshold',
        label: 'ABB.Powertrain.Frontend.fftEchartFilterThreshold',
    },
];

export const echartLegendNames = {
    sensorAsset: ['Axial', 'Tangential', 'Radial', 'PiezoFFTJsonData'],
    msrAsset: ['Horizontal', 'Axial']
};

export const echartViews = {
    FREQUENCY: 'FREQUENCY',
    ORDER_OF_SPEED: 'ORDER_OF_SPEED'
};

export const echartColors = {
    FREQUENCY: 'rgb(57, 111, 170)',
    SPEED: '#afacac',
    BSF: 'rgba(78, 121, 167, 1)',
    BPFO: 'rgba(89, 161, 79, 1)',
    BPFI: 'rgba(242, 142, 44, 1)',
    CAGE: 'rgba(176, 122, 161, 1)',
    HARMONICS: 'rgba(0, 0, 0, 1)',
};

export const echartHarmonicsLabel = 'ABB.Powertrain.Frontend.fftEchartHarmonics';
